
const docBody = document.body

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.id === 'tapcart-web-banner') {
        console.log('tapcart-web-banner added');
        setTimeout(() =>{
          docBody.classList.add('show-thing')
        }, 15000);
      }
    })
  })
});

observer.observe(docBody, {childList: true });